import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import FormControl from "../../components/Common/FormControl";
import FormControlTextArea from "../../components/Common/FormControlTextArea";
import FormLabel from "../../components/Common/FormLabel";
import FormSelect from "../../components/Common/FormSelect";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { getOfferDetails } from "../../redux/Slices/sentOfferSlice";

const LeadForm = ({
  formData,
  errors,
  onChange,
  isEditMode,
  showLeadInfo,
  leadInfo,
  countryOptions,
  languageOptions,
}) => {
  const { trans } = useCustomTranslation();
  const [offerData, setOfferData] = useState({});
  const dispatch = useDispatch();
  const [oneTimePayment, setoneTimePayment] = useState(0);

  useEffect(() => {
    const sendOffer = async () => {
      try {
        const offerResponse = await dispatch(
          getOfferDetails({ leadOfferDetailsId: formData.leadId })
        ).unwrap();
        // eslint-disable-next-line react-hooks/exhaustive-deps

        setOfferData(offerResponse?.leadOfferDetails);

        if (offerResponse?.oneTimePayments != null) {
          let totalOneTimePayment = 0;
          for (let i = 0; i < offerResponse?.oneTimePayments.length; i++) {
            totalOneTimePayment =
              totalOneTimePayment +
              offerResponse?.oneTimePayments[i].paymentAmount;
          }
          setoneTimePayment(totalOneTimePayment);
        }
      } catch (err) {
        console.error("Failed to send offer:", err);
      }
    };

    formData?.leadId && sendOffer();
  }, [dispatch, formData.leadId]);
  return (
    <div>
      {/* Personal Information Section */}
      <div className="mb-4">
        {/* {isEditMode && (
          <h6 className="section-title mb-3">
            {trans("LeadPage.personalInformation")}
          </h6>
        )} */}

        <Row className="mb-3">
          <Col md={3}>
            <FormLabel label={trans("Common.firstName")} required />
            <FormControl
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={onChange}
              isInvalid={!!errors.firstName}
              feedback={errors.firstName}
              placeholder={trans("Common.enterFirstName")}
              autoComplete="leadform-firstname"
              isDisabled={!isEditMode}
            />
          </Col>
          <Col md={3}>
            <FormLabel label={trans("Common.lastName")} />
            <FormControl
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={onChange}
              isInvalid={!!errors.lastName}
              feedback={errors.lastName}
              placeholder={trans("Common.enterLastName")}
              autoComplete="leadform-lastname"
              isDisabled={!isEditMode}
            />
          </Col>

          <Col md={3}>
            <FormLabel label={trans("Common.email")} required />
            <FormControl
              type="email"
              name="email"
              value={formData.email}
              onChange={onChange}
              isInvalid={!!errors.email}
              feedback={errors.email}
              placeholder={trans("Common.enterEmail")}
              autoComplete="leadform-email"
              isDisabled={!isEditMode}
            />
          </Col>
          <Col md={3}>
            <FormLabel label={trans("Common.phoneNumber")} />
            <FormControl
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={onChange}
              isInvalid={!!errors.phoneNumber}
              feedback={errors.phoneNumber}
              placeholder={trans("Common.enterPhoneNumber")}
              autoComplete="leadform-phone"
              isDisabled={!isEditMode}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          {/* {isEditMode && (
            <Col md={3}>
              <FormLabel label={trans("LeadPage.arrived")} />
              <FormControl
                type="text"
                name="arrived"
                value={formData.createdOn}
                onChange={onChange}
                isInvalid={false}
                disabled
                placeholder={trans("LeadPage.arrivedPlaceholder")}
                autoComplete="leadform-arrived"
                isDisabled={!isEditMode}
              />
            </Col>
          )} */}
          <Col md={3}>
            <FormSelect
              label={trans("Common.country")}
              name="country"
              value={formData.country || offerData.country}
              onChange={onChange}
              options={[
                { value: "", label: trans("Common.selectCountry") },
                ...countryOptions,
              ]}
              isInvalid={!!errors.country}
              feedback={errors.country}
              placeholder={trans("Common.selectCountry")}
              autoComplete="leadform-country"
              isDisabled={!isEditMode}
            />
          </Col>
          <Col md={3}>
            <FormSelect
              label={trans("Common.language")}
              name="language"
              value={formData.language}
              onChange={onChange}
              options={languageOptions}
              isInvalid={!!errors.language}
              feedback={errors.language}
              placeholder={trans("Common.selectLanguage")}
              autoComplete="leadform-language"
              isDisabled={!isEditMode}
            />
          </Col>
          {formData?.status === "Won" && (
            <>
              <Col md={3}>
                <FormLabel label="Billing Cycle" />
                <FormSelect
                  name="billingCycle"
                  value={offerData?.billingCycle || ""}
                  onChange={onChange}
                  options={[
                    { label: "Select Billing Cycle", value: "" },
                    {
                      label: "Start of the Month",
                      value: "startOfTheMonth",
                    },
                    { label: "Month Apart", value: "monthApart" },
                  ]}
                  isDisabled={!isEditMode}
                />
              </Col>

              <Col md={3}>
                <FormLabel label="Subscription Start Date" />
                <FormControl
                  type="date"
                  name="billingStartDate"
                  value={offerData?.billingStartDate || ""}
                  onChange={onChange}
                  isDisabled={!isEditMode}
                />
              </Col>
            </>
          )}
        </Row>
        {/* Extra fields only when status = Won */}
        {formData?.status === "Won" && (
          <>
            {/* Row 1 */}
            <Row className="mb-3 mt-2">
              <Col md={3}>
                <FormLabel label="Subscription Duration (months)" />
                <FormControl
                  type="number"
                  name="subscriptionDuration"
                  value={offerData?.subscriptionDuration || ""}
                  onChange={onChange}
                  isDisabled={!isEditMode}
                />
              </Col>

              <Col md={3}>
                <FormLabel label="Currency" />
                <FormSelect
                  name="currency"
                  value={offerData?.currency || ""}
                  onChange={onChange}
                  options={[
                    { label: "Select Currency", value: "" },
                    { label: "INR", value: "INR" },
                    { label: "USD", value: "USD" },
                    { label: "EUR", value: "EUR" },
                  ]}
                  isDisabled={!isEditMode}
                />
              </Col>
              <Col md={3}>
                <FormLabel label="Monthly Amount" />
                <FormControl
                  type="number"
                  name="monthlyAmount"
                  value={offerData?.monthlyAmount || ""}
                  onChange={onChange}
                  isInvalid={!!errors?.monthlyAmount}
                  feedback={errors?.monthlyAmount}
                  isDisabled={!isEditMode}
                />
              </Col>

              <Col md={3}>
                <FormLabel label={trans("LeadPage.freePeriodEndOn")} />
                <FormControl
                  type="date"
                  name="freePeriodEndDate"
                  value={offerData?.freePeriodEndDate || ""}
                  onChange={onChange}
                  isInvalid={!!errors?.freePeriodEndDate}
                  feedback={errors?.freePeriodEndDate}
                  isDisabled={!isEditMode}
                />
              </Col>
            </Row>

            {/* Row 2 */}
            <Row className="mb-3">
              <Col md={3}>
                <FormLabel label={trans("LeadPage.setupFee")} />
                <FormControl
                  type="text"
                  name="setupFee"
                  value={offerData?.setupFee || ""}
                  onChange={onChange}
                  isInvalid={!!errors?.setupFee}
                  feedback={errors?.setupFee}
                  placeholder={trans("LeadPage.enterSetupFee")}
                  autoComplete="leadform-setupFee"
                  isDisabled={!isEditMode}
                />
              </Col>

              <Col md={3}>
                <FormLabel label={trans("LeadPage.oneTimePayment")} />
                <FormControl
                  type="number"
                  name="oneTimePayment"
                  value={oneTimePayment || 0}
                  onChange={onChange}
                  isInvalid={!!errors?.oneTimePayment}
                  feedback={errors?.oneTimePayment}
                  placeholder={trans("LeadPage.enterOneTimeFee")}
                  autoComplete="leadform-oneTimePayment"
                  isDisabled={!isEditMode}
                />
              </Col>
              <Col md={3}>
                <FormLabel label={trans("LeadPage.billingDate")} />
                <FormControl
                  type="date"
                  name="oneTimeBillingDate"
                  value={offerData?.firstPaymentDate || ""}
                  onChange={onChange}
                  isInvalid={!!errors?.oneTimeBillingDate}
                  feedback={errors?.oneTimeBillingDate}
                  placeholder={trans("LeadPage.enterBillingDate")}
                  autoComplete="leadform-oneTimeBillingDate"
                  isDisabled={!isEditMode}
                />
              </Col>
            </Row>
          </>
        )}
        <Row className="mb-3">
          <Col md={12} className="mt-2">
            <FormLabel label={trans("Common.notes")} />
            <FormControlTextArea
              name="note"
              value={formData.note || offerData?.leadNotes || ""}
              onChange={onChange}
              isInvalid={!!errors.note}
              feedback={errors.note}
              placeholder={trans("Common.enterNotes")}
              autoComplete="leadform-note"
              isDisabled={!isEditMode}
            />
          </Col>
        </Row>
      </div>

      {/* Lead Information Section */}
      {showLeadInfo && leadInfo && (
        <div>
          <h6 className="section-title mb-3">
            {trans("LeadPage.leadInformation")}
          </h6>
          <Row>
            <Col md={3}>
              <div className="info-item">
                <FormLabel label={trans("LeadPage.goal")} />
                <p>{leadInfo.goal}</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="info-item">
                <FormLabel label={trans("LeadPage.sex")} />
                <p>{leadInfo.sex}</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="info-item">
                <FormLabel label={trans("LeadPage.age")} />
                <p>{leadInfo.age}</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="info-item">
                <FormLabel label={trans("LeadPage.motivation")} />
                <p>{leadInfo.motivation}</p>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default LeadForm;
